import { discountsSelector, calculateOrderSummary } from 'order-summary'
import { REGISTRATION_FORM_NAME } from './constants'
import { createSelector } from 'reselect'

export const getMembershipRegistrationOrderSummary = createSelector(
  (_, props) => props.membershipPlan.price,
  discountsSelector(REGISTRATION_FORM_NAME),
  (price, discounts) => calculateOrderSummary(price, discounts)
)
